import React, { Fragment } from "react";
import { useListContext, useRefresh, useUnselectAll } from "react-admin";
import AssignMultipleDriverDialog from "./AssignMultipleDriverDialog";
import CannotPickMultipleDialog from "./CannotPickMultipleDialog";
import EndMultipleDeliveryDialog from "./EndMultipleDeliveryDialog";
import StartMultipleDeliveryDialog from "./StartMultipleDeliveryDialog";
import VerifyMultipleDeliveryDialog from "./VerifyMultipleDeliveryDialog";

interface DeliveryBulkActionsProps {
  selectedIds?: number[];
  data?: any[];
}

const DeliveryBulkActions: React.FC<DeliveryBulkActionsProps> = ({
  selectedIds,
}) => {
  const refresh = useRefresh();
  const unselectAll = useUnselectAll("deliveries");
  const listContext = useListContext();

  const statusFilter = listContext?.filterValues?.status;
  const hasSelection = selectedIds && selectedIds.length > 0;

  const handleActionComplete = () => {
    refresh();
    unselectAll();
  };

  const canBulkAssign =
    hasSelection &&
    (!statusFilter || ["new", "driver_assigned"].includes(statusFilter));
  const canBulkStart =
    hasSelection && (!statusFilter || statusFilter === "driver_assigned");
  const canBulkEnd =
    hasSelection && (!statusFilter || statusFilter === "picked");
  const canBulkCannotStart =
    hasSelection && (!statusFilter || statusFilter === "driver_assigned");
  const canBulkVerify =
    hasSelection && (!statusFilter || statusFilter === "delivered");

  return (
    <Fragment>
      {canBulkAssign && (
        <AssignMultipleDriverDialog
          selectedIds={selectedIds || []}
          onComplete={handleActionComplete}
        />
      )}
      {canBulkStart && (
        <StartMultipleDeliveryDialog
          selectedIds={selectedIds || []}
          onComplete={handleActionComplete}
        />
      )}
      {canBulkEnd && (
        <EndMultipleDeliveryDialog
          selectedIds={selectedIds || []}
          onComplete={handleActionComplete}
        />
      )}
      {canBulkCannotStart && (
        <CannotPickMultipleDialog
          selectedIds={selectedIds || []}
          onComplete={handleActionComplete}
        />
      )}
      {canBulkVerify && (
        <VerifyMultipleDeliveryDialog
          selectedIds={selectedIds || []}
          onComplete={handleActionComplete}
        />
      )}
    </Fragment>
  );
};

export default DeliveryBulkActions;
